export default {
  EMPLOYEE_RECORD: {
    ADMINISTRATIVE: 'Additional HR information', BANK: 'Bank details', MEDICAL: 'Administrative occupational health follow-up',
    QUALIFICATIONS: 'Languages and authorisations', CV: 'Employee CV', PAYROLL: 'Employee remuneration',
    TITLE: 'Title', OTHER_FIRST_NAMES: 'Other first names', BIRTH_COUNTRY: 'Country of birth',
    SS_CENTER: 'Social security centre address', CLASSIFICATION: 'Additional classification', COEFFICIENT: 'Coefficient', POSITION: 'Position',
    SPOUSE_LAST_NAME: 'Spouse last name', SPOUSE_FIRST_NAME: 'Spouse first name', AGE: 'Age as of today', BIRTH_DATE: 'Date of birth',
    BIRTH_DEPARTMENT: 'Department of birth', FAMILY: 'Family', CHILDREN: 'Recorded children', LEGACY_CHILD_COUNT: 'Existing number of children',
    CHILDREN_INCOMPLETE: 'Detailed records do not replace the existing count.', GENDER: 'Gender', GENDER_OTHER: 'Other', DEPENDENT: 'Dependent',
    LEGACY_EMERGENCY: 'Existing emergency contact', EMERGENCY: 'Additional administrative contacts',
    INDEPENDENT_CONTACTS: 'This list is independent of the existing contact.', CONTACT_NAME: 'Contact name', PHONE: 'Phone', RELATION: 'Relationship',
    ADDRESS: 'Address', PRIMARY: 'Primary', MAKE_PRIMARY: 'Set as primary', REPLACEMENT_REQUIRED: 'Choose the replacement primary contact before deleting this one.',
    HOLDER: 'Account holder', IBAN: 'IBAN', BIC: 'BIC', BANK_ADDRESS: 'Bank address', BANK_NOTICE: 'No payment or transfer is made from this record.',
    LANGUAGE: 'Language', LEVEL: 'Level', NATIVE: 'Native language', CERTIFICATION: 'Authorisation', OBTAINED: 'Obtained on', EXPIRES: 'Expires on',
    VISIT: 'Occupational health visit', VACCINATION: 'Vaccination - administrative follow-up', MEDICAL_KIND: 'Event type',
    APPOINTMENT: 'Appointment date and time', TIMEZONE: 'Time zone: {{zone}}', OFFSET: 'UTC offset for this ambiguous time', MEDICAL_CENTER: 'Medical centre',
    PROFESSIONAL: 'Professional', ADMIN_REASON: 'Administrative reason', RENEW_BEFORE: 'Renew before',
    NO_CLINICAL_DATA: 'Do not enter any diagnosis, clinical result or medical comment.', EDUCATION: 'Education', EXPERIENCE: 'Previous work experience',
    DIPLOMA: 'Recorded qualification', SCHOOL: 'Institution', STUDY_END: 'End of studies', MENTION: 'Distinction', COMPANY: 'Company',
    JOB: 'Position held', START: 'Start', END: 'End', DESCRIPTION: 'Description', NO_LINKED_CV: 'No CV candidate is linked to this employee.',
    PAYROLL_TAB: 'Remuneration tab', MONTH_FROM: 'From month', MONTH_TO: 'To month', PAYROLL_COLUMN: 'Pay item to chart',
    PAYROLL_NO_MAPPING: 'Displayed pay items are those configured for your company.', EVOLUTION: 'Change over the loaded period', ACCOUNT: 'Account information',
    PASSWORD_DEFINED: 'Password defined', IDENTITY_INFO: 'Identity information recorded', YES: 'Yes', NO: 'No', NOT_RECORDED: 'Not recorded',
    UNAVAILABLE: 'Data unavailable', LOADING: 'Loading…', EMPTY: 'No entries recorded.', FORBIDDEN: 'You do not have access to this section.',
    LOAD_ERROR: 'Unable to load this section.', RETRY: 'Retry', ADD: 'Add', EDIT: 'Edit', DELETE: 'Delete', DELETE_CONFIRM: 'Confirm deletion of this entry?',
    SAVED: 'Changes saved.', SAVE_ERROR: 'Save failed; your input has been retained.',
    CONFLICT: 'This entry has changed since loading. Review the current version before replacing your input.',
    UNSAVED_TITLE: 'Unsaved changes', UNSAVED_MESSAGE: 'Leave this section without saving the changes?', STAY: 'Stay', LEAVE: 'Leave without saving',
    SAVING: 'Saving; please wait.', COMMENTS: 'Administrative comments', COMMENT: 'Comment', ADD_COMMENT: 'Add a comment',
    IMMUTABLE_COMMENTS: 'To correct a comment, add a new one.', HISTORY: 'History of additional information', DATE_TIME: 'Date and time', AUTHOR: 'Author',
    ACTION: 'Action', BEFORE: 'Before', AFTER: 'After', CREATED: 'Creation', UPDATED: 'Update', DELETED: 'Deletion', ADDED_COMMENT: 'Comment added',
    FILTER_FROM: 'From date', FILTER_TO: 'To date', ALL_ACTIONS: 'All actions', REQUIRED: 'This field is required.', MAX_LENGTH: 'Maximum {{max}} characters.',
    INVALID_DATE: 'Invalid or inconsistent date.', INVALID_TIME: 'Invalid appointment date or time.', AMBIGUOUS_TIME: 'Specify the UTC offset for this time.',
    INVALID_IBAN: 'Invalid IBAN: country, length or checksum.', INVALID_BIC: 'Invalid BIC.', INVALID_PHONE: 'Invalid phone number.',
    SOURCE_ERROR: 'The existing source is unavailable or inconsistent.', TIMEOUT: 'The request timed out. Your input has been retained.',
    APPLY_FILTERS: 'Apply filters', RELOAD_CURRENT: 'Review current version', USE_CURRENT: 'Replace my input with the current version', ALL: 'All',
    CURRENT_VERSION: 'Current version', NEW_ENTRY: 'New entry', LOGIN: 'Login identifier', ROLE: 'Role', STATUS: 'Status',
    CURRENT_NOT_ON_PAGE: 'This entry is absent from the loaded page (moved or deleted). Browse the list to find it; your input has been retained.',
    INVALID_VALUE: 'Invalid value.',
    HISTORY_SUBTITLE: 'Changes to contacts, at a glance.', HISTORY_FILTERS: 'Filters',
    HISTORY_NEWEST: 'Newest first', HISTORY_OLDEST: 'Oldest first', HISTORY_RESET: 'Reset',
    HISTORY_NO_FIELD_CHANGES: 'No contact detail changes recorded.',
    HISTORY_GENERAL_SUBTITLE: 'Recorded activity in this section, at a glance.', HISTORY_NO_DETAILS: 'No additional details recorded.',
  },
  ALERT: {
    MyAlerts: 'My Alerts',
    TYPE: 'Type',
    NOMEN: 'Name of entity',
  },
  COMM: {
    TYPE: 'Type',
    DESC: 'description',
  },
  NOTE: {
    NOTE: 'NOTE',
    COMMENTAIRE: 'COMMENT',
  },
  STRATEGIE: {
    NOM: 'STRATEGY NAME',
    NOMPARAMETRE: 'SET NAME',
    EVENT: 'EVENT',
    TXT: 'Transversal teams to which the user belongs: ',
  },
  CARD: {
    BTNACTIF: 'Active',
    BTNDESACTIF: 'Inactive',
    BTNALUMNI: 'Alumni',
    ACCOUNTSTATUS: 'Account status',
    VALID: 'Active',
    ENATT: 'Awaiting registration',
    TAUXCOMP: 'Profile completion rate',
    RDVTERMINE: 'Number of appointments completed',
    LISTCOMMENT: 'List of notes and comments',
    ENTRETIENS: 'Interviews',
    EDIT_PHOTO: 'Edit photo',
    Fonction: 'Job title',
    CONTRACT_INTERNSHIP: 'Internship',
    CONTRACT_APPRENTICESHIP: 'Apprenticeship',
    CONTRACT_EXTERNAL: 'External contractor',
    ONBOARDING_TRACKING: 'Onboarding and offboarding tracking',
    ALL_DOCUMENTS: 'All documents',
    GROUP_EMPLOYEE_RECORD: 'Employee record',
    GROUP_TIME_AND_ABSENCE: 'Time and absence',
    GROUP_PERFORMANCE: 'Development and performance',
    GROUP_MANAGEMENT: 'Management and compensation',
    GROUP_RELATIONS: 'Relationships and company life',
    HR_INFO: 'Useful HR information',
    ALERTS_REMINDERS: 'Alerts and reminders',
    SUMMARY_LOADING: 'Loading summary…',
    SUMMARY_ERROR: 'The summary is currently unavailable.',
    NO_REMINDERS: 'No alerts or reminders to display.',
    SHOW_REMINDERS: 'View all',
    HIDE_REMINDERS: 'Show less',
    REMINDERS_LIMIT: '{{shown}} items displayed out of {{total}}',
    HIGH_POTENTIAL: 'High potential',
    SPECIAL_FOLLOW_UP: 'Special follow-up',
    ONBOARDING_PAUSED: 'Onboarding paused',
    ONBOARDING_ACTIVE: 'Onboarding in progress',
    ONBOARDING_DONE: 'Onboarding completed',
    OFFBOARDING_PAUSED: 'Offboarding paused',
    OFFBOARDING_ACTIVE: 'Offboarding in progress',
    OFFBOARDING_DONE: 'Offboarding completed',
    ENTRY_DATE: 'Start date',
    EXIT_DATE: 'Departure date',
    TENURE: 'Length of service',
    TENURE_DAYS: '{{count}} days',
    TENURE_MONTH: '{{count}} month',
    TENURE_MONTHS: '{{count}} months',
    TRIAL_END: 'Trial period end',
    NO_DUE_DATE: 'No due date',
    MORE_PROFILE_INFO: 'More information',
    LISTJOURSTRAVAILLES: 'List of working days',
    LISTCONGE: 'List of leave requests',
    LISTPLANNING: 'Travel planning list',
    LISTMANAGES: 'List of managed employees',
    LISTMANAGESREMUNERATION: 'List of managed employees - Compensation module',
    Presentation: 'Presentation',
    HISTORIQUERDV: 'Appointment history',
    STRATEGIE: 'Strategies targeting this employee',
    DISPO: 'Submitted availability',
    Communities: 'Communities',
    Alertes: 'Alerts',
    FORMATIONS: 'Training',
    COMPETENCES: 'Skills',
    NOTES: 'Internal notes',
  },
  ENTRETIENS: {
    TITLE: 'Interviews',
    SUBTITLE: 'Read-only list of interviews concerning this collaborator.',
    LOADING: 'Loading interviews...',
    FILTER_TYPE: 'Interview type',
    FILTER_STATUS: 'Status',
    ALL_TYPES: 'All types',
    ALL_STATUSES: 'All statuses',
    INTERVIEWS_TITLE: 'Collaborator interviews',
    INTERVIEWS_SUBTITLE: 'Interviews where this collaborator is the evaluated person.',
    CROSS_FEEDBACKS_TITLE: 'Cross-feedbacks',
    CROSS_FEEDBACKS_SUBTITLE: 'Cross-feedbacks concerning this collaborator.',
    EMPTY_INTERVIEWS: 'No interview found for this collaborator.',
    EMPTY_FILTERED: 'No interview matches the selected filters.',
    EMPTY_CROSS_FEEDBACKS: 'No cross-feedback found for this collaborator.',
    COL_TYPE: 'Interview type',
    COL_MANAGER: 'Manager / contributor',
    COL_CONTRIBUTOR: 'Contributor',
    COL_DATE: 'Date',
    COL_STATUS: 'Status',
    COL_ACTIONS: 'Actions',
    VIEW: 'Read',
    COUNT: '{{count}} item(s)',
    COUNT_FILTERED: '{{filtered}} / {{total}} interview(s)',
    PREVIOUS: 'Previous',
    NEXT: 'Next',
    LOAD_ERROR: 'Unable to load this collaborator interviews.',
    OPEN_ERROR: 'Unable to open this interview.',
    IMPORTED_PDF_NOT_FOUND: 'The imported PDF could not be found for this interview.',
    IMPORTED_PDF_OPEN_ERROR: 'Unable to open the imported PDF.',
  },
  USER_NOTES: {
    TITLE: 'Internal notes',
    SUBTITLE: 'Add confidential information visible only to administrators',
    DRAG_DROP_HINT: 'Drag and drop images into the editor to embed them automatically',
    SAVE_SUCCESS: 'Note saved successfully',
    SAVE_ERROR: 'Unable to save the note right now',
    LOAD_ERROR: 'Unable to load the note',
    EMPTY_MESSAGE: 'Please write some content before saving',
    COMMUNITIES: 'Communities',
    ALERTES: 'Alerts',
    FORMATIONS: 'Trainings',
    COMPETENCES: 'Skills',
    NOTES: 'Internal notes',
    VISIBLE_TO_MANAGERS: 'Allow managers to see this note',
    NOT_ALLOWED: 'This note is unavailable because administrators have not allowed sharing with managers.',
    READONLY_INFO: 'Managers can read the note only when an administrator shares it.',
  },
  USERDETAILS: {
    USER_NOTES: {
      TITLE: 'Internal notes',
      SUBTITLE: 'Add confidential information visible only to administrators',
      DRAG_DROP_HINT: 'Drag and drop images into the editor to embed them automatically',
      SAVE_SUCCESS: 'Note saved successfully',
      SAVE_ERROR: 'Unable to save the note right now',
      LOAD_ERROR: 'Unable to load the note',
      EMPTY_MESSAGE: 'Please write some content before saving',
      VISIBLE_TO_MANAGERS: 'Allow managers to see this note',
      NOT_ALLOWED: 'This note is unavailable because administrators have not allowed sharing with managers.',
      READONLY_INFO: 'Managers can read the note only when an administrator shares it.',
    },
  },
  COLLAB: {
    listeCollaborateursManages: 'List of managed employees',
    ajouterCollaborateur: 'Add employee',
    aucunCollaborateurManage: 'No managed employees',
    aucunCollaborateurSansManager: 'No employees without manager',
    photo: 'Photo',
    nom: 'Last name',
    prenom: 'First name',
    equipe: 'Team',
    service: 'Department',
    site: 'Site',
    btnSave: 'Save',
    CONFIRMATION_RETIRER_MANAGER: 'Are you sure you want to remove this employee from your list of managed persons?',
    EDIT: {
      BTN_CANCEL: 'Cancel',
      dateAutorisationEmbauche: 'Hiring authorization date',
      dateAutorisationLicenciement: 'Dismissal authorization date',
      dateAutorisationDemande: 'Authorization date or authorization request date',
      titre: 'Title',
      titreAutorisation: 'Authorization title',
      numeroOrdreTitre: 'Title order number',
      dateDelivranceTitre: 'Title issue date',
      dateExpirationTitre: 'Title expiration date',
      ERROR_DATE_EXPIRATION_AFTER_DELIVRANCE:
        'The title expiration date must be after the title issue date.',
    }
  },
}
